import React, { useState, useEffect } from "react";
import api from "../../../services/api";
import { useParams } from "react-router-dom";
import { Content, SubContent, Main } from "../../../components/Layout";
import { ModalAddTask } from "../../../components/Modal";
import { Row, Col } from "react-bootstrap";
import useWrapper from "../../../hooks/useWrapper";
import { useOutletContext } from "react-router-dom";
import CalendarBig from "../../../components/CalendarBig";

export default function Graduate() {
  const { setbreadcrumb, config, token } = useWrapper();
  const { commercial, reload, setreload } = useOutletContext();
  const { commercialId } = useParams();
  const [reload2, setreload2] = useState(false);
  const [selectEvent, setselectEvent] = useState();
  const [events2, setevents2] = useState();
  const [loading, setloading] = useState();

  useEffect(() => {
    (async function () {
      setloading(true);
      const { data: _events } = await api.get(
        "calendars",
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            commercial_id: commercialId,
            active: 1,
          },
        },
        config,
      );

      let _only_events = _events.map(__event => {
        const _date = new Date(__event.date_start);
        return {
          start: _date,
          end: _date,
          all_day: !!__event.all_day,
          title: __event.title,
          status: __event.status,
          done: __event.done,
          id: __event.id,
        };
      });
      setevents2(_only_events);
      setloading(false);
    })();
  }, [reload2]);

  useEffect(() => {
    if (commercial?.institution?.name) {
      setbreadcrumb([{ label: "Turmas", url: "/groups" }, { label: commercial.institution.name }]);
    }
  }, [commercial]);

  return (
    <>
      <Main>
        <ModalAddTask
          reload={() => {
            setreload2(!reload2);
          }}
          itemId={selectEvent}
          show={!!selectEvent || selectEvent === ""}
          onHide={() => setselectEvent(null)}
          turmaId={commercialId}
        />
        <Content noBG="true">
          <SubContent>
            <Row>
              <Col>
                <CalendarBig
                  reload={reload2}
                  setreload={setreload2}
                  events={events2}
                  onSelectEvent={__ev => {
                    setselectEvent(__ev.id || "");
                  }}
                  loading={loading}
                  commercial_id={commercialId}
                  commercial_name={commercial?.institution?.name}
                  can_print={true}
                />
              </Col>
            </Row>
          </SubContent>
        </Content>
      </Main>
    </>
  );
}
